module.exports = __webpack_public_path__ + "img/appAsset--alerts-ax.ddb5facb.svg";